import { AgentApplicationStatus } from "@/core/constants";
import { 
  UserCourseAttendeeModel,
  SimpleLookupModel,
  SimpleTextLookupModel,
  UploadFileModel,
  UserModel
 } from "@/core/models";

export class AgentApplicationCollectionModel {
  agentApplicationId: number;
  firstName: string;
  lastName: string;
  statusId: number;
  status: AgentApplicationStatus;
  statusName: string;
  unionName: string;
  addedOn: Date;
  activeOn: Date|null;
  endsOn: Date|null;
}

export class AgentApplicationListLookupModel {
  agentApplicationStatuses: SimpleLookupModel[] = [];
}

export class AgentApplicationModel {
  agentApplicationId: number;
  user: UserModel;
  firstName: string = "";
  lastName: string = "";
  knownAs: string = "";
  dateOfBirth: Date;
  address: string = "";
  companyName: string = "";
  companyAddress: string = "";
  numberOfClients: string = "";
  unionId: number;
  agentApplicationStatusId: number;
  activeOn: Date|null;
  endsOn: Date|null;
  nextBackendProgressionStatusId: number|null = null;
  uploadedFiles: UploadFileModel[] = [];
  proofOfIdentity: string = "";
  declarationFile: string = "";
  proofOfIdentityFiles: UploadFileModel[] = [];
  declarationFiles: UploadFileModel[] = [];
  activeCourseAttendee: UserCourseAttendeeModel;
  activePrerequisiteCertificates: object;
}

export class UpdateAgentApplicationLookupModel {
  agentApplicationStatuses: SimpleLookupModel[] = [];
  unions: SimpleLookupModel[] = [];
  numberOfClientsOptions: SimpleTextLookupModel[] = [];
}